<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1000"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="Profile入库"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 9 }"
          :wrapper-col="{ span: 14 }"
          @submit="handleSubmit"
        >
          <a-col :span="11">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="32"
                :placeholder="itemsPlaceholder"
                :style="{ color: itemsValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="itemsInput"
                @blur="analyzeItemsInput"
              />
            </a-form-item>
            <a-form-item label="总数" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ itemsCount }}</span>
            </a-form-item>
            <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ duplicateItemsCount }}</span>
            </a-form-item>
            <div v-if="itemsErrorMsg" style="color: red">{{ itemsErrorMsg }}</div>
          </a-col>

          <a-col :span="13">
            <a-form-item label="供应商">
              <a-select
                v-decorator="['profile_supplier_id', { rules: [{ required: true, message: '请选择供应商' }] }]"
                show-search
                option-filter-prop="children"
                :loading="loadingSupplierOptions"
              >
                <a-select-option v-for="opt in supplierOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="PRP重复下载规则">
              <a-select
                v-decorator="['prp_id', {
                  initialValue: 5,
                  rules: [{ required: true, message: '请选择PRP规则' }]
                }]"
              >
                <a-select-option :value="1">1 - 全态开放（任意EID）</a-select-option>
                <a-select-option :value="2">2 - 删除/就绪态开放（任意EID）</a-select-option>
                <a-select-option :value="3">3 - 全态绑定（同一EID）</a-select-option>
                <a-select-option :value="4">4 - 删除/就绪态绑定（同一EID）</a-select-option>
                <a-select-option :value="5">5 - 错误敏感模式（同一EID）</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="状态">
              <a-select
                v-decorator="['status', {
                  initialValue: 'Available',
                  rules: [{ required: true, message: '请选择状态' }]
                }]"
              >
                <a-select-option value="Available">未被使用</a-select-option>
                <a-select-option value="Preparing">已准备</a-select-option>
                <a-select-option value="Unavailable">不可用</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Profile费(元)">
              <a-input-number
                v-decorator="['profile_fee', { initialValue: 0, rules: [{ validator: checkProfileFee }] }]"
                :min="0"
                :precision="3"
                :step="0.001"
                style="width: 100%"
                @change="(v) => { this.profileFeeWatch = v }"
              />
            </a-form-item>

            <a-form-item label="总费用预览">
              <span>{{ totalProfileFeePreview }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'
import { importProfileInventories } from '@/api/profile_inventory'
import { formatFloat } from '@/utils/filter'

const maxItemLines = 100000

export default {
  name: 'ImportProfileInventory',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'import_profile_inventories' }),
      submitting: false,
      itemsInput: '',
      items: [],
      itemsCount: 0,
      duplicateItemsCount: 0,
      itemsValidateStatus: '',
      itemsErrorMsg: '',
      itemsPlaceholder: '每行一条，格式：ICCID|MSISDN|激活码\n' +
        'MSISDN 可留空，例如：8986...||LPA:1$...\n' +
        '也支持制表符分隔（可直接从 Excel 粘贴三列）',
      supplierOptions: [],
      loadingSupplierOptions: false,
      profileFeeWatch: 0
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    totalProfileFeePreview() {
      const fee = Number(this.profileFeeWatch) || 0
      return formatFloat(fee * this.items.length)
    }
  },
  created() {
    this.fetchSupplierOptions()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) this.supplierOptions = res.data
        this.loadingSupplierOptions = false
      })
    },
    checkProfileFee(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback()
        return
      }
      if (Number(value) < 0) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Profile费不能为负')
        return
      }
      callback()
    },
    analyzeItemsInput() {
      if (!this.itemsInput) {
        this.items = []
        this.itemsCount = 0
        this.duplicateItemsCount = 0
        this.itemsValidateStatus = 'error'
        this.itemsErrorMsg = '请录入Profile'
        return
      }

      const lines = this.itemsInput.split(/\r?\n/).map((l) => l.trim()).filter((l) => l)
      if (lines.length > maxItemLines) {
        this.items = []
        this.itemsCount = 0
        this.duplicateItemsCount = 0
        this.itemsValidateStatus = 'error'
        this.itemsErrorMsg = `数量不能超过${maxItemLines}`
        return
      }

      const parsed = []
      const errorLines = []
      for (const line of lines) {
        const parts = line.includes('\t') ? line.split('\t') : line.split('|')
        if (parts.length < 2) {
          errorLines.push(line)
          continue
        }
        const iccid = (parts[0] || '').trim()
        let msisdn = ''
        let activationCode = ''
        if (parts.length === 2) {
          activationCode = (parts[1] || '').trim()
        } else {
          msisdn = (parts[1] || '').trim()
          activationCode = parts.slice(2).join('|').trim()
        }
        if (!iccid || !activationCode) {
          errorLines.push(line)
          continue
        }
        parsed.push({ iccid, msisdn, activation_code: activationCode })
      }

      if (errorLines.length > 0) {
        this.items = []
        this.itemsCount = 0
        this.duplicateItemsCount = 0
        this.itemsValidateStatus = 'error'
        this.itemsErrorMsg = '存在格式错误行（需 ICCID 与激活码）'
        return
      }

      const uniqIccids = this.$lodash.uniq(parsed.map((p) => p.iccid))
      this.items = parsed.filter((p, idx, arr) => arr.findIndex((x) => x.iccid === p.iccid) === idx)
      this.itemsCount = parsed.length
      this.duplicateItemsCount = parsed.length - uniqIccids.length

      if (this.items.length === 0) {
        this.itemsValidateStatus = 'error'
        this.itemsErrorMsg = '请录入Profile'
      } else if (this.duplicateItemsCount > 0) {
        this.itemsValidateStatus = 'error'
        this.itemsErrorMsg = '录入的 ICCID 存在重复'
      } else {
        this.itemsValidateStatus = 'success'
        this.itemsErrorMsg = ''
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.analyzeItemsInput()
      if (this.itemsValidateStatus === 'error') {
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        importProfileInventories({
          ...values,
          items: this.items
        }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>操作成功，具体结果请至 【Profile资源入库】-【入库记录】 查看</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>
